export default "__VITE_ASSET__1f730846__"